import PropTypes from "prop-types";
import { formatNumber } from "../../utils/utils";
import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

/**
 * Displays a short summary text and number of assets.
 * @param {string} text - The summary text to display.
 * @param {string} popoverText - The text to explain the summary.
 * @param {number} numberOfAssets - The number of assets.
 */

const TextDisplay = ({ text, popoverText, numberOfAssets }) => (
  <div>
    <div className="relative mb-2">
  <div className="flex justify-center items-center gap-2">
    <h3 className="text-lg sm:text-xl font-semibold text-center">{text}</h3>

    <Popover className="relative">
      {({ open }) => (
        <>
          <PopoverButton className="focus:outline-none">
            <FontAwesomeIcon
              icon={faInfoCircle}
              className="cursor-pointer text-gray-500 text-base"
            />
          </PopoverButton>

          <PopoverPanel
            className="absolute z-50 w-64 sm:w-80 md:w-96 p-4 bg-white shadow-md border rounded-lg text-gray-800"
            anchor={{ to: "bottom-start", gap: 4 }}
          >
            <p className="text-sm whitespace-pre-line">
              {popoverText}
            </p>
          </PopoverPanel>
        </>
      )}
    </Popover>
  </div>
  </div>




    <div className="mb-2 text-sm sm:text-base flex flex-col">
      <span>Anzahl der Anlagen:</span>
      <span>{formatNumber(numberOfAssets, 0, 0)}</span>
    </div>

  </div>
);
    

TextDisplay.propTypes = {
  text: PropTypes.string.isRequired,
  numberOfAssets: PropTypes.number.isRequired,
};

export default TextDisplay;
